module.exports = __webpack_public_path__ + "img/hometh4.3093ca17.png";